import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import { extractInitialsFromFullName } from '../utils/activityProcessor';

import DA from '../store/ReduxAccess';

import CrmTextField from './CrmTextField';

const userProfilePanelStyles = {
  titleBoxContainer: {},
  titleBox: {
    height: '58px',
    width: '395px',
    display: 'flex',
    alignItems: 'center',
  },
  titleIcon: {
    height: '50px',
    width: '50px',
    margin: '0 10px 0 15px',
    position: 'relative',
    display: 'flex',
  },
  titleBox_text: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: 'calc(100% - 75px)',
    '&:after': {
      content: '',
      clear: 'both',
    },
  },
  title: {
    color: '#0c0d0d',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px',
    cursor: 'pointer',
    maxWidth: '70%',
    '&:hover': {
      color: '#0c0dee',
    },
  },
  subtitle: {
    color: '#0c0d0d',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '19px',
  },
  emailDiv: {
    marginTop: '12px',
  },
  emailSpan: {
    fontWeight: 600,
  },
  profileImageComponent: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    backgroundColor: '#dce3e6',
    color: 'rgba(12,13,13,0.32)',
    position: 'relative',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '50px',
  },
  profileImageComponent_circle: {
    verticalAlign: 'center',
    borderRadius: '50%',
  },
  changePasswordForm: {
    border: '1px solid black',
    paddingBottom: '10px',
    paddingRight: '20px',
    marginTop: '12px',
  },
  textField: {
    margin: '10px 10px 0',
    width: '100%',
  },
  passwordButtonsDiv: {
    textAlign: 'right',
    padding: '12px 8px 8px 0',
  },
  u_ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

/*
Call this with
    <ResetPasswordPanel
        userEmail={userInfo} // must include at least personId and email
        newPassword={this.state.newPassword} // current state for the password input
        confirmPassword={this.state.confirmPassword} // current state for the confirmPassword input
        onPasswordChange={(stateKey, newValue) => this.changePassword(stateKey, newValue)}
    />
*/

class ResetPasswordPanel extends React.Component {
  handlePasswordChange(event, stateKey) {
    this.props.onPasswordChange(stateKey, event.target.value);
  }

  render() {
    const { classes, userInfo, newPassword, confirmPassword } = this.props;
    const person = DA.getPersonById(userInfo.personId);
    const fullName = person.preferredFullName;
    const initials = extractInitialsFromFullName(fullName);
    const userCategory = DA.getRoleOfUserWithId(userInfo.id);
    return (
      <div className={classes.titleBoxContainer}>
        <div className={classes.titleBox}>
          <div className={classes.titleIcon}>
            <div className={cx(classes.profileImageComponent, classes.profileImageComponent_circle)}>{initials}</div>
          </div>
          <div className={classes.titleBox_text}>
            <div className={cx(classes.title, classes.u_ellipsis)}>{fullName}</div>
            <div className={cx(classes.subtitle, classes.u_ellipsis)}>User Category: {userCategory}</div>
          </div>
        </div>
        <div className={cx(classes.subtitle, classes.emailDiv, classes.u_ellipsis)}>
          <span className={classes.emailSpan}>Email:</span> {userInfo.email}
        </div>
        <div className={classes.changePasswordForm}>
          <div>
            <CrmTextField
              className={classes.textField}
              label="New Password"
              password
              value={newPassword}
              onChange={(event) => this.handlePasswordChange(event, 'newPassword')}
            />
            <CrmTextField
              className={classes.textField}
              label="Confirm New Password"
              password
              value={confirmPassword}
              onChange={(event) => this.handlePasswordChange(event, 'confirmPassword')}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(userProfilePanelStyles)(ResetPasswordPanel);
